import React, { useEffect, useRef } from 'react';

const StatesMap = () => {
  const mapRef = useRef();

  useEffect(() => {
    const drawVisualization = () => {
      if (!window.google || !window.google.visualization) return;
      const google = window.google;
      const data = new google.visualization.DataTable();

      // add your data and options here.
      data.addColumn('string', 'Country');
      data.addColumn('number', 'Value');
      data.addColumn({ type: 'string', role: 'tooltip' });
      data.addRows([[{ v: 'US-WA', f: 'Washington' }, 0, '']]);
      data.addRows([[{ v: 'US-OR', f: 'Oregon' }, 1, '']]);
      data.addRows([[{ v: 'US-ND', f: 'North Dakota' }, 2, '']]);
      data.addRows([[{ v: 'US-MI', f: 'Michigan' }, 3, '']]);
      data.addRows([[{ v: 'US-WI', f: 'Wisconsin' }, 4, '']]);
      data.addRows([[{ v: 'US-UT', f: 'Utah' }, 5, '']]);
      data.addRows([[{ v: 'US-AZ', f: 'Arizona' }, 6, '']]);
      data.addRows([[{ v: 'US-CO', f: 'Colorado' }, 7, '']]);
      data.addRows([[{ v: 'US-NM', f: 'New Mexico' }, 8, '']]);
      data.addRows([[{ v: 'US-TX', f: 'Texas' }, 9, '']]);
      data.addRows([[{ v: 'US-NE', f: 'Nebraska' }, 10, '']]);
      data.addRows([[{ v: 'US-KS', f: 'Kansas' }, 11, '']]);
      data.addRows([[{ v: 'US-OK', f: 'Oklahoma' }, 12, '']]);
      data.addRows([[{ v: 'US-IA', f: 'Iowa' }, 13, '']]);
      data.addRows([[{ v: 'US-MO', f: 'Missouri' }, 14, '']]);
      data.addRows([[{ v: 'US-AR', f: 'Arkansas' }, 15, '']]);
      data.addRows([[{ v: 'US-IL', f: 'Illinois' }, 16, '']]);
      data.addRows([[{ v: 'US-IN', f: 'Indiana' }, 17, '']]);
      data.addRows([[{ v: 'US-OH', f: 'Ohio' }, 18, '']]);
      data.addRows([[{ v: 'US-PA', f: 'Pennsylvania' }, 19, '']]);
      data.addRows([[{ v: 'US-WV', f: 'West Virginia' }, 20, '']]);
      data.addRows([[{ v: 'US-MD', f: 'Maryland' }, 21, '']]);
      data.addRows([[{ v: 'US-MS', f: 'Mississippi' }, 22, '']]);
      data.addRows([[{ v: 'US-AL', f: 'Alabama' }, 23, '']]);
      data.addRows([[{ v: 'US-GA', f: 'Georgia' }, 24, '']]);
      data.addRows([[{ v: 'US-FL', f: 'Florida' }, 25, '']]);
      data.addRows([[{ v: 'US-NC', f: 'North Carolina' }, 26, '']]);
      data.addRows([[{ v: 'US-SC', f: 'South Carolina' }, 27, '']]);
      data.addRows([[{ v: 'US-TN', f: 'Tennessee' }, 28, '']]);
      data.addRows([[{ v: 'US-KY', f: 'Kentucky' }, 29, '']]);
      data.addRows([[{ v: 'US-VA', f: 'Virginia' }, 30, '']]);
      data.addRows([[{ v: 'US-ME', f: 'Maine' }, 31, '']]);
      data.addRows([[{ v: 'US-MA', f: 'Massachusetts' }, 32, '']]);
      data.addRows([[{ v: 'US-DE', f: 'Delaware' }, 33, '']]);
      data.addRows([[{ v: 'US-AK', f: 'Alaska' }, 34, '']]);
      data.addRows([[{ v: 'US-HI', f: 'Hawaii' }, 35, '']]);
      data.addRows([[{ v: 'US-CA', f: 'California' }, 36, '']]);
      data.addRows([[{ v: 'US-MN', f: 'Minnesota' }, 37, '']]);
      data.addRows([[{ v: 'US-NY', f: 'New York' }, 38, '']]);
      data.addRows([[{ v: 'US-CT', f: 'Connecticut' }, 39, '']]);
      data.addRows([[{ v: 'US-NJ', f: 'New Jersey' }, 40, '']]);
      data.addRows([[{ v: 'US-VT', f: 'Vermont' }, 41, '']]);
      data.addRows([[{ v: 'US-NH', f: 'New Hampshire' }, 42, '']]);

      const options = {
        //... add your options here
        backgroundColor: { fill: '#FFFFFF', stroke: '#FFFFFF', strokeWidth: 0 },
        colorAxis: {
          minValue: 0,
          maxValue: 42,
          colors: [
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
            '#CD7CB2',
          ],
        },
        legend: 'none',
        datalessRegionColor: '#A6DBD4',
        displayMode: 'regions',
        enableRegionInteractivity: 'true',
        resolution: 'provinces',
        region: 'US',
        keepAspectRatio: true,
        width: null,
        height: null,
        tooltip: {
          textStyle: { color: '#444444' },
          trigger: 'focus',
          isHtml: false,
        },
      };

      const chart = new google.visualization.GeoChart(mapRef.current);
      chart.draw(data, options);
    };

    const loadScript = src => {
      return new Promise(resolve => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.onload = resolve;
        document.head.appendChild(script);
      });
    };

    const initialize = async () => {
      if (!window.google || !window.google.visualization) {
        await loadScript('https://www.gstatic.com/charts/loader.js');
        await loadScript('https://www.google.com/jsapi');
        window.google.charts.load('42', { packages: ['geochart'] });
        window.google.charts.setOnLoadCallback(drawVisualization);
      } else {
        drawVisualization();
      }
      window.addEventListener('resize', drawVisualization);
    };

    if (typeof window !== 'undefined') initialize();

    return () => {
      if (typeof window !== 'undefined')
        window.removeEventListener('resize', drawVisualization);
    };
  }, []);

  return <div ref={mapRef} id='map_1695834795728'></div>;
};

export default StatesMap;
